import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { onM365AppTrigger, onModuleTrigger } from 'owa-nova';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "AppBar" */ './lazyIndex'));

registerLazyOrchestrator(onM365AppTrigger, lazyModule, m => m.onM365AppTriggerOrchestrator);
registerLazyOrchestrator(onModuleTrigger, lazyModule, m => m.onModuleTriggerOrchestrator);

export { default as AppBar } from './components/AppBar';
